import { __assign } from "tslib";
import * as yup from "yup";
import ShareAuthenticatorField from "./ShareAuthenticatorField";
import ShareLinkTypeField from "./ShareLinkTypeField";
export var getShareSettingsFields = function (opts) {
    if (opts === void 0) { opts = {}; }
    var validate = yup
        .number()
        .min(1, "Access count must be greater than or equal to 1")
        .required("Access count is required");
    if (opts.maxAccessCount) {
        validate = validate.max(opts.maxAccessCount, "Access count must be less than or equal to ".concat(opts.maxAccessCount));
    }
    return {
        expires_at: {
            label: "Expiration",
            LabelProps: {
                placement: "top",
                minWidth: "180px",
            },
            FieldProps: {
                type: "dateTime",
                maxDate: opts === null || opts === void 0 ? void 0 : opts.maxDate,
            },
        },
        max_access_count: {
            label: "Access count",
            LabelProps: {
                placement: "top",
                minWidth: "180px",
            },
            schema: validate,
            FieldProps: {
                type: "number",
                InputProps: {
                    inputProps: __assign({ min: 1 }, (!!(opts === null || opts === void 0 ? void 0 : opts.maxAccessCount) && {
                        max: opts.maxAccessCount,
                    })),
                },
            },
        },
    };
};
export var getCreateShareFields = function () {
    return {
        authenticators: {
            label: "",
            LabelProps: {
                placement: "top",
            },
            component: ShareAuthenticatorField,
            schema: yup
                .array()
                .min(1, "At least one recipient is required")
                .required("At least one recipient is required"),
            getFieldValue: function (values) {
                var _a;
                return {
                    shareType: values === null || values === void 0 ? void 0 : values.shareType,
                    authenticators: (_a = values === null || values === void 0 ? void 0 : values.authenticators) !== null && _a !== void 0 ? _a : [],
                    authenticatorType: values === null || values === void 0 ? void 0 : values.authenticatorType,
                };
            },
            onFieldChanged: function (value, values) {
                var value_ = value;
                return __assign({}, value_);
            },
        },
        title: {
            label: "Title",
            isHidden: function (values) { return values.shareType === "link"; },
            LabelProps: {
                placement: "start",
                info: "The recipient will see this in emails and after gaining access.",
                FormControlLabelSx: {
                    ".MuiStack-root": {
                        alignItems: "end",
                    },
                },
            },
        },
        message: {
            label: "Message",
            isHidden: function (values) { return values.shareType === "link"; },
            LabelProps: {
                placement: "start",
                info: "The recipient will see this in emails and after gaining access.",
                FormControlLabelSx: {
                    marginTop: 1,
                    alignItems: "baseline",
                    ".MuiStack-root": {
                        alignItems: "end",
                    },
                },
            },
            FieldProps: {
                type: "multiline",
                placeholder: "Optionally provide details..",
            },
        },
        link_type: {
            label: "Folder access",
            isHidden: function (values) { return values.contentType !== "folder"; },
            LabelProps: {
                placement: "top",
                TypographyProps: {
                    variant: "body1",
                    color: "textPrimary",
                    paddingBottom: 1,
                },
            },
            component: ShareLinkTypeField,
            FieldProps: {
                type: "singleSelect",
                options: {
                    valueOptions: [
                        {
                            value: "download",
                            label: "Download",
                            description: "People with this link can download files",
                        },
                        {
                            value: "upload",
                            label: "Upload",
                            description: "People with this link can upload files to the shared folder",
                        },
                        {
                            value: "editor",
                            label: "Editor",
                            description: "People with this link can download, upload and edit all files within the folder",
                        },
                    ],
                },
            },
        },
    };
};
